import { Divider } from "primereact/divider"
import logoEposi from '../assets/eposi_preto.png';
export const InformacaoEposi = () => {
    return (
        <div>
        <Divider className="automotiva" align="left">
        <div className="flex-score justify-content-between justify-content-center">
 
          <img
            style={{ width: "150px", position: "relative" }}
            src={logoEposi}
            alt="logo"
          />
        </div>
      </Divider>
      </div>
    )
}